import React from "react";
import Page from "common/components/Page";
import { Typography } from "@mui/material";

const ErrorPage = () => {
  return (
    <Page>
      <Typography variant="h5" component="h1">
        An error has occured.
      </Typography>
      <Typography variant="subheading" component="h1">
        Please try again soon.
      </Typography>
    </Page>
  );
};

export default ErrorPage;
